import i18n from '@/utils/i18n';
import OfflineIcon from '@assets/icons/offline.svg';
import React from 'react';
import { Button } from './button';
import { Col, Grid, Row } from './layout';
import { createStyles } from '@/contexts/theme-context';
import { ORDER_GUIDE_ROUTES } from '@/navigators/routes';
import { OrderGuideStackParams } from '@/navigators/types';
import { StackNavigationProp } from '@react-navigation/stack';
import { Text } from 'react-native';
import { TYPOGRAPHY } from '@/styles';
import { useNavigation } from '@react-navigation/native';

type Navigation = StackNavigationProp<
  OrderGuideStackParams,
  ORDER_GUIDE_ROUTES.Base
>;

export const OfflineComponent: React.FC = () => {
  const [styles, theme] = useStyles();
  const { navigate } = useNavigation<Navigation>();

  const navigateToOrderGuide = () => {
    navigate(ORDER_GUIDE_ROUTES.Base);
  };
  return (
    <Grid style={styles.grid}>
      <Row>
        <Col size={3} />
        <Col size={6} style={styles.content}>
          <OfflineIcon stroke={theme.sk.color.icon.secondary} />
          <Text style={[TYPOGRAPHY.p, styles.copy]}>
            {i18n.t('offline_card.copy')}
          </Text>
          <Button
            onPress={navigateToOrderGuide}
            size="small"
            style={styles.button}
            textStyle={[TYPOGRAPHY.pSemiBold, styles.buttonTextStyle]}
            trackingData={{
              name: 'offline_card.view_order_guide',
            }}
            type="secondary"
          >
            {i18n.t('offline_card.cta')}
          </Button>
        </Col>
        <Col size={3} />
      </Row>
    </Grid>
  );
};

const useStyles = createStyles((theme) => ({
  button: {
    alignSelf: 'center',
    borderRadius: 20,
    borderWidth: 1.5,
    paddingHorizontal: 16,
  },
  buttonTextStyle: {
    fontSize: 14,
  },
  content: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  copy: {
    color: theme.sk.color.text.secondary,
    lineHeight: 25,
    marginBottom: 32,
    marginTop: 16,
    maxWidth: 275,
    textAlign: 'center',
  },
  grid: {
    justifyContent: 'center',
  },
}));
